var LABEL_POSITION = {
  LEFT: 'left',
  NONE: 'none',
  TOP: 'top'
};
var DROPDOWN_SIZE = {
  REGULAR: 'regular',
  SMALL: 'small',
  TINY: 'tiny'
};
var DROPDOWN_VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary'
};
var MENU_POSITION = {
  ABSOLUTE: 'absolute',
  FIXED: 'fixed',
  STATIC: 'static'
};
var MENU_PLACEMENT = {
  AUTO: 'auto',
  BOTTOM: 'bottom',
  TOP: 'top'
};
var MENU_ALIGNMENT = {
  LEFT: 'left',
  RIGHT: 'right'
};

export { DROPDOWN_SIZE, DROPDOWN_VARIANT, LABEL_POSITION, MENU_ALIGNMENT, MENU_PLACEMENT, MENU_POSITION };
//# sourceMappingURL=Dropdown.constants.js.map
